'use strict';

const SoaModel = require('bunsen/models/SoaModel');
const {sessionStorage} = require('dibs-browser-storage');
const endpoints = require('dibs-endpoints');

const SESSION_STORAGE_NAMESPACE = 'userRegionalInfo';

const RegionalInfo = SoaModel.extend({
    url() {
        return endpoints.userRegionalInfo();
    },

    initialize() {
        const regionalInfo = sessionStorage.getItem(SESSION_STORAGE_NAMESPACE);
        if (regionalInfo) {
            this.set(regionalInfo);
        }
    },

    getInfo(payload = {}) {
        const {ipAddress} = payload;

        if (this.get('cached')) {
            return Promise.resolve();
        } else {
            return Promise
                .resolve(this.fetch({data: {ipAddress}}))
                .catch((err = {}) => {
                    console.log(`unable to fetch ip address: ${err.status} - ${err.responseText}`);
                });
        }
    },

    parse(response, options) {
        response = SoaModel.prototype.parse.call(this, response, options);

        if (response && response.dataList) {
            const result = response.dataList[0];
            Object.assign(result, {cached: true});
            sessionStorage.setItem(SESSION_STORAGE_NAMESPACE, result);
            return result;
        }

        return {};
    }
});

module.exports = RegionalInfo;



// WEBPACK FOOTER //
// ./assets/js/global/models/RegionalInfoModel.es.js